export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-07-12 at 6.20.10 PM.81388dfc.jpeg";